
const index = resolve =>{
  import('./index/index').then(module=>{
    resolve(module)
  })}


const rules = resolve =>{
  import('./lucky_draw/rules').then(module=>{
    resolve(module)
  })
}

const my_number = resolve =>{
  import('./lucky_draw/my_number').then(module=>{
    resolve(module)
  })
}

const lucky_draw = resolve =>{
  import('./lucky_draw/lucky_draw').then(module=>{
    resolve(module)
  })
}
const navigation = resolve =>{
  import('./navigation/navigation').then(module=>{
    resolve(module)
  })
}
const refuel = resolve =>{
  import('./refuel/refuel').then(module=>{
    resolve(module)
  })
}
const pay = resolve =>{
  import('./refuel/pay').then(module=>{
    resolve(module)
  })
}
const special_offer = resolve =>{
  import('./special_offer/special_offer').then(module=>{
    resolve(module)
  })
}
const today_price = resolve =>{
  import('./today_price/today_price').then(module=>{
    resolve(module)
  })
}
const voucher_center = resolve =>{
  import('./voucher_center/voucher_center').then(module=>{
    resolve(module)
  })
}

export default [
  {
    path: '/',
    name: 'index',
    component: index,
    meta: {
      auth: false,
      title: '首页',
      nav: true,
      keepAlive:true
    }
  },
  {
    name: 'lucky_draw',
    path: '/index/lucky_draw',
    component: lucky_draw,
    meta: {
      nav: false,
      auth: false,
      title: '幸运抽奖',
      keepAlive: false
    }
  },
  {
    name: 'lucky_draw',
    path: '/index/lucky_draw',
    component: lucky_draw,
    meta: {
      nav: false,
      auth: true,
      title: '幸运抽奖',
      keepAlive: false
    }
  },
  {
    name: 'rules',
    path: '/index/rules',
    component: rules,
    meta: {
      nav: false,
      auth: false,
      title: '抽奖规则',
      keepAlive: false
    }
  },
  {
    name: 'my_number',
    path: '/index/my_number',
    component: my_number,
    meta: {
      nav: false,
      auth: true,
      title: '抽奖号码',
      keepAlive: false
    }
  },
  {
    name: 'navigation',
    path: '/index/navigation',
    component: navigation,
    meta: {
      nav: false,
      auth: false,
      title: '一键导航',
      keepAlive: false
    }
  },
  {
    name: 'refuel',
    path: '/index/refuel',
    component: refuel,
    meta: {
      nav: false,
      auth: true,
      title: '一键加油',
      keepAlive: false
    }
  },
  {
    name: 'pay',
    path: '/pay/pay',
    component: pay,
    meta: {
      nav: false,
      auth: true,
      title: '支付详情',
      keepAlive: false
    }
  },
  {
    name: 'special_offer',
    path: '/index/special_offer',
    component: special_offer,
    meta: {
      nav: false,
      auth: false,
      title: '优惠活动',
      keepAlive: false
    }
  },
  {
    name: 'today_price',
    path: '/index/today_price',
    component: today_price,
    meta: {
      nav: false,
      auth: false,
      title: '今日油价',
      keepAlive: false
    }
  },
  {
    name: 'voucher_center',
    path: '/pay/voucher_center',
    component: voucher_center,
    meta: {
      nav: false,
      auth: true,
      title: '储值卡充值',
      keepAlive: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/module/index/router.js